import HttpService from '@/services/http/http.service';

export default class AdminUserService {
	constructor() {
		this.http = new HttpService();
	}

	createUser(user) {
		return this.http.post('admin/user', user);
	}

	updateUser(user) {
		return this.http.put(`admin/user/${user.id}`, user);
	}

	getUsers(search, page, limit) {
		return this.http.get('admin/user', {
			search,
			page,
			limit,
		});
	}

	get(userId) {
		return this.http.get(`admin/user/${userId}`);
	}

	enrolments(userId) {
		return this.http.get(`admin/user/${userId}/enrolment`);
	}
}
